<template>
  <div class="task-work-order-scope-item-action-cell">
    <div v-if="isWorkScopeItem">
      <input
        :id="$id(`itemCompletion${task.id}`)"
        type="checkbox"
        @click.stop
        @change="changeItemStatus"
        v-model="task.is_completed"
      />
      <label :for="$id(`itemCompletion${task.id}`)" @click.stop>
        Completed
      </label>
    </div>
    <div class="actions-cell" v-else>
      <button class="button small ghost" @click.stop="updateTaskOrWorkOrder">
        <span class="uppercase">Update Task</span>
      </button>
    </div>
  </div>
</template>

<script>
import UpdateTaskForm from "../../../forms/UpdateTaskForm";

export default {
  name: "TaskWorkOrderScopeItemActionCell",
  props: {
    task: Object,
    workOrder: Object
  },
  computed: {
    isWorkScopeItem() {
      return this.task && this.task.path === "scope_items";
    }
  },
  methods: {
    changeItemStatus() {
      const bool = this.task.is_completed;
      this.$store.dispatch("updateContractScopeItemStatus", {
        ...this.task,
        status: bool ? "completed" : "not-started",
        isDashboard: true
      });
    },
    updateTaskOrWorkOrder() {
      this.$store.commit("setCreateEditComponentParams", {
        createEditComponent: UpdateTaskForm,
        createEditComponentData: this.task
          ? { task: this.task }
          : { workOrder: this.workOrder },
        createEditComponentIsShown: true
      });
    }
  }
};
</script>

<style scoped></style>
